import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AppContext } from './../shared';

import { SaveRouteService } from './save-route.service';


@Component({
  selector: 'save-route',
  template: require('./save-route.component.html'),
  styles: [require('./save-route.component.scss')],
  providers: [SaveRouteService],
})
export class SaveRouteComponent {
  @Output() onClose = new EventEmitter();

  constructor(private service: SaveRouteService) {
  }

  @Input()
  set display(toDisplay: boolean) {
    this.service.show = toDisplay;
    this.service.checkIfLoggedIn();
  }

  @Input()
  set origins(originIds: Array<any>) {
    this.service.origins = originIds;
    this.service.updateRoutes();
  }

  @Input()
  set destinations(destinationIds: Array<any>) {
    this.service.destinations = destinationIds;
    this.service.updateRoutes();
  }

  close() {
    this.onClose.emit();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/save-route/save-route.component.ts